module.exports = __webpack_public_path__ + "static/img/tab-ten.c006e367.png";